import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { Disposition } from "../../../types/tempTypes";
import {
  ICampaignLeadType,
  ILeadDispositionLog,
  ILeadLogTableResponseType,
} from "../../../types/campaignTypes";

type InitialState = {
  lead: ICampaignLeadType;
  leadLogTable: ILeadLogTableResponseType;
  // dispositionList: Disposition[];
};
const leadInitialData = {
  leadId: 0,
  name: "",
  countryCode: "",
  phoneNumber: "",
  email: "",
  status: "",
  role: "",
  source: "",
  leadType: "",
  lastDispositionId: null,
  lastSubDispositionId: null,
  lastSubDispositionChildId: null,
  campaignId: 0,
  insurerId: 0,
  businessPartnerId: 0,
  referrerId: null,
  productId: null,
  profileId: null,
  importerId: null,
  stateId: null,
  countryId: 0,
  city: "",
  address: null,
  pinCode: null,
  gender: null,
  salutation: null,
  referralCode: "",
  partnerName: "",
  remarks: "",
  policyNumber: null,
  productName: null,
  planNameIc: null,
  occupation: null,
  officeCode: null,
  employeeContactNo: null,
  policyAnnualPremium: null,
  policySurrenderValue: null,
  policyPremiumPending: null,
  approxInvesmentAmount: 3443,
  dob: null,
  policyIssueDate: "",
  policyDueDate: "",
  leadDate: "",
  createdAt: "",
  updatedAt: "",
  insurer: null,
  businessPartner: null,
  product: null,
  country: null,
  state: null,
  referrer: null,
  profile: null,
};

const initialState: InitialState = {
  lead: leadInitialData,
  leadLogTable: {
    data: [],
    paginationMetaData: { take: 0, count: 0 },
  },
  // dispositionList: [],
};

export const campaignSlice = createSlice({
  name: "campaign",
  initialState,
  reducers: {
    setCampaignLeadData: (state, action: PayloadAction<ICampaignLeadType>) => {
      state.lead = action.payload;
    },
    setLeadLogTable: (
      state,
      action: PayloadAction<ILeadLogTableResponseType>
    ) => {
      state.leadLogTable = action.payload;
    },
  },
});

export const { setCampaignLeadData, setLeadLogTable } = campaignSlice.actions;
const campaignReducer = campaignSlice.reducer;
export default campaignReducer;
